/* ==========================================================================
 * custom-bundle.js — Quantity Bundle Widget
 * --------------------------------------------------------------------------
 * - Gia sau giam tinh REAL-TIME tu data attributes (khong hardcode).
 * - Anh nho theo mau (thumbnail variant) o moi o chon.
 * - Custom name dang POPUP (Personalisation), moi don vi 1 dong.
 * - Free shipping chi hien khi qty tier >= nguong (free_shipping_min_qty).
 * - Sync: chon Color (variant picker theme) -> dien tat ca o cua tier.
 * - Add nhieu variant vao gio qua /cart/add.js (items:[...]), gan _bundle_id
 *   va _bundle_discount (de Shopify Function tru dung % o checkout).
 * ========================================================================== */
(function () {
  'use strict';

  /* Format tien theo dung money_format cua shop (giong Shopify.formatMoney) —
     nhat quan voi theme, khong doi theo locale trinh duyet. */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'"); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' '); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function makeMoneyFormatter(format, currency) {
    var hasFormat = format && /\{\{\s*\w+\s*\}\}/.test(format);
    return function (cents) {
      if (hasFormat) return formatMoney(cents, format);
      // Khong co money_format -> fallback Intl theo currency
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
      } catch (e) {
        return formatMoney(cents, '${{amount}}');
      }
    };
  }

  function applyDiscount(cents, percent) {
    if (!percent) return cents;
    return Math.round((cents * (100 - percent)) / 100);
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document
          .querySelectorAll('.cart-count-bubble span[aria-hidden], .cart-count-bubble, .cart-count, [data-cart-count], .header__cart-count, .site-header__cart-count')
          .forEach(function (el) {
            if (el.hasAttribute('data-cart-count') || /count/.test(el.className)) el.textContent = count;
          });
        return cart;
      })
      .catch(function () {});
  }

  function notifyThemeCart(cart, addedItems) {
    var handled = false;
    try {
      if (window.Shopify && window.Shopify.publish && window.PUB_SUB_EVENTS) {
        window.Shopify.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'custom-bundle', cartData: cart });
        handled = true;
      }
    } catch (e) {}
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      try {
        if (typeof drawer.renderContents === 'function' && cart && cart.sections) drawer.renderContents(cart);
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.classList.add('active', 'is-open', 'open');
        handled = true;
      } catch (e) {}
    }
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart, items: addedItems } }));
    });
    if (window.jQuery) { try { window.jQuery(document.body).trigger('cart:updated', [cart]); } catch (e) {} }
    return handled;
  }

  function showToast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.setAttribute('role', 'status');
    t.style.cssText =
      'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
      'background:#1a1a1a;color:#fff;padding:.7rem 1.1rem;border-radius:999px;' +
      'font-size:.9rem;z-index:99999;box-shadow:0 6px 20px rgba(0,0,0,.25);opacity:0;transition:opacity .2s';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 250); }, 2200);
  }

  /* ====================================================================== */
  function initBundle(root) {
    if (root.dataset.cbndlInit) return;
    root.dataset.cbndlInit = '1';

    var money = makeMoneyFormatter(root.dataset.moneyFormat, root.dataset.currency);
    var enableCustomName = root.dataset.enableCustomName === 'true';
    var cartBehavior = root.dataset.cartBehavior || 'auto';
    var productTitle = root.dataset.productTitle || 'Item';
    var freeShipMin = parseInt(root.dataset.freeShipMin, 10) || 0;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.cbndl__card'));
    var submitBtn = root.querySelector('[data-submit]');
    var submitText = root.querySelector('[data-submit-text]');
    var spinner = root.querySelector('[data-spinner]');
    var errorEl = root.querySelector('[data-error]');
    var shipTeaser = root.querySelector('[data-ship-teaser]');

    function optData(select) {
      var opt = select.options[select.selectedIndex];
      return {
        id: opt.value,
        price: parseInt(opt.dataset.price, 10) || 0,
        compare: parseInt(opt.dataset.compare, 10) || parseInt(opt.dataset.price, 10) || 0,
        available: opt.dataset.available === 'true',
        image: opt.dataset.image || '',
        label: opt.textContent
      };
    }

    /* -- Cap nhat khoi gia cho 1 tier card -- */
    function renderCardPrice(card) {
      var qty = parseInt(card.dataset.qty, 10) || 1;
      var discount = parseInt(card.dataset.discount, 10) || 0;
      var selects = card.querySelectorAll('.cbndl__select');

      var totalAnchor = 0;
      var totalNow = 0;
      selects.forEach(function (s) {
        var d = optData(s);
        totalAnchor += d.compare;
        totalNow += applyDiscount(d.price, discount);
      });
      var unitAnchor = Math.round(totalAnchor / qty);
      var unitNow = Math.round(totalNow / qty);

      var unitPriceEl = card.querySelector('[data-unit-price]');
      var unitCompareEl = card.querySelector('[data-unit-compare]');
      var totalPriceEl = card.querySelector('[data-total-price]');
      var totalCompareEl = card.querySelector('[data-total-compare]');

      // Moi the chi 1 so chinh + 1 so gach (dong deu): qty1 -> don gia, qty>1 -> tong.
      if (qty > 1) {
        if (unitPriceEl) unitPriceEl.textContent = '';
        if (unitCompareEl) unitCompareEl.textContent = '';
        if (totalPriceEl) totalPriceEl.textContent = money(totalNow);
        if (totalCompareEl) totalCompareEl.textContent = totalAnchor > totalNow ? money(totalAnchor) : '';
      } else {
        if (unitPriceEl) unitPriceEl.textContent = money(unitNow);
        if (unitCompareEl) unitCompareEl.textContent = unitAnchor > unitNow ? money(unitAnchor) : '';
        if (totalPriceEl) totalPriceEl.textContent = '';
        if (totalCompareEl) totalCompareEl.textContent = '';
      }
    }

    /* -- Cap nhat hien thi dropdown tuy bien (anh + ten + active) theo select -- */
    function updateDropdownDisplay(select) {
      var row = select.closest('.cbndl__selector-row');
      if (!row) return;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var thumb = row.querySelector('[data-dd-thumb]');
      var label = row.querySelector('[data-dd-label]');
      if (thumb && opt.dataset.image) thumb.src = opt.dataset.image;
      if (label) label.textContent = (opt.textContent || '').split('—')[0].trim();
      var menu = row.querySelector('[data-dd-menu]');
      if (menu) {
        menu.querySelectorAll('.cbndl__dd-opt').forEach(function (o) {
          o.classList.toggle('is-active', o.getAttribute('data-value') === opt.value);
        });
      }
    }

    /* -- Dieu khien variant picker goc cua Dawn -> Dawn tu doi anh chinh (native, muot) -- */
    function driveMainPicker(select) {
      var opt = select.options[select.selectedIndex];
      var option1 = opt && opt.dataset.option1;
      if (!option1) return;
      var picker = document.querySelector('variant-selects, variant-radios');
      if (!picker) return;
      var done = false;
      picker.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (!done && r.value === option1) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
          done = true;
        }
      });
      if (done) return;
      var sel = picker.querySelector('select');
      if (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === option1) {
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }
    }

    /* -- Dong/mo dropdown tuy bien -- */
    function closeAllMenus(except) {
      root.querySelectorAll('[data-dd]').forEach(function (dd) {
        if (dd === except) return;
        var m = dd.querySelector('[data-dd-menu]');
        var b = dd.querySelector('[data-dd-btn]');
        if (m) m.hidden = true;
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    function selectedCard() {
      var checked = root.querySelector('.cbndl__radio:checked');
      return checked ? checked.closest('.cbndl__card') : null;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    /* -- Teaser ngoai: chi hien khi tier chon CHUA du dieu kien (de nhac mua them);
       khi da du (qty >= nguong) thi an vi da co banner trong the -- */
    function updateShipping(card) {
      if (!shipTeaser) return;
      var qty = card ? (parseInt(card.dataset.qty, 10) || 1) : 0;
      shipTeaser.hidden = (freeShipMin && qty >= freeShipMin);
    }

    /* ---------------- Custom name POPUP (Personalisation) ---------------- */
    var modal = root.querySelector('[data-cn-modal]');
    var modalBody = root.querySelector('[data-cn-body]');
    var cnActiveCard = null;

    function buildCnModal(card) {
      if (!card || !modalBody) return;
      var qty = parseInt(card.dataset.qty, 10) || 1;
      var selects = card.querySelectorAll('.cbndl__select');
      var names = card.__cnNames || [];
      modalBody.innerHTML = '';
      for (var i = 0; i < qty; i++) {
        var sel = selects[i];
        var opt = sel ? sel.options[sel.selectedIndex] : null;
        var imgSrc = opt && opt.dataset.image ? opt.dataset.image : '';
        var color = sel ? optData(sel).label.split('—')[0].trim() : '';

        var rowEl = document.createElement('div');
        rowEl.className = 'cbndl__cn-row';

        var im = document.createElement('img');
        im.className = 'cbndl__cn-img';
        im.src = imgSrc;
        im.alt = '';
        rowEl.appendChild(im);

        var field = document.createElement('div');
        field.className = 'cbndl__cn-field';

        var nm = document.createElement('div');
        nm.className = 'cbndl__cn-name';
        nm.textContent = productTitle + ' #' + (i + 1);
        field.appendChild(nm);

        var vr = document.createElement('div');
        vr.className = 'cbndl__cn-variant';
        vr.textContent = color;
        field.appendChild(vr);

        var inp = document.createElement('input');
        inp.type = 'text';
        inp.className = 'cbndl__cn-input';
        inp.maxLength = 30;
        inp.placeholder = 'Type here';
        inp.value = names[i] || '';
        field.appendChild(inp);

        var cnt = document.createElement('div');
        cnt.className = 'cbndl__cn-count';
        var cs = document.createElement('span');
        cs.textContent = String(inp.value.length);
        cnt.appendChild(cs);
        cnt.appendChild(document.createTextNode('/30'));
        field.appendChild(cnt);

        inp.addEventListener('input', (function (span) {
          return function () { span.textContent = String(this.value.length); };
        })(cs));

        rowEl.appendChild(field);
        modalBody.appendChild(rowEl);
      }
    }

    function openModal() { if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; } }
    function closeModal() { if (modal) { modal.hidden = true; document.body.style.overflow = ''; } }

    root.querySelectorAll('[data-cn-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        cnActiveCard = btn.closest('.cbndl__card');
        buildCnModal(cnActiveCard);
        openModal();
      });
    });
    root.querySelectorAll('[data-cn-close], [data-cn-cancel]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    var confirmBtn = root.querySelector('[data-cn-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        if (cnActiveCard && modalBody) {
          var inputs = modalBody.querySelectorAll('.cbndl__cn-input');
          cnActiveCard.__cnNames = Array.prototype.map.call(inputs, function (i) { return i.value.trim(); });
          var filled = cnActiveCard.__cnNames.filter(Boolean).length;
          var openBtn = cnActiveCard.querySelector('[data-cn-open]');
          if (openBtn) openBtn.classList.toggle('cbndl__cn-open--filled', filled > 0);
        }
        closeModal();
      });
    }
    // Dua modal ra thang <body> de position:fixed luon phu ca man hinh
    // (tranh bi "nhot" trong cot info neu theme co transform/sticky). Giu accent.
    if (modal) {
      var accentVal = getComputedStyle(root).getPropertyValue('--cb-accent');
      if (accentVal) modal.style.setProperty('--cb-accent', accentVal.trim());
      document.body.appendChild(modal);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    /* ---------------- Dropdown tuy bien: wiring ---------------- */
    root.querySelectorAll('[data-dd]').forEach(function (dd) {
      var btn = dd.querySelector('[data-dd-btn]');
      var menu = dd.querySelector('[data-dd-menu]');
      var row = dd.closest('.cbndl__selector-row');
      var select = row ? row.querySelector('.cbndl__select') : null;
      if (!btn || !menu || !select) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = menu.hidden;
        closeAllMenus(dd);
        menu.hidden = !willOpen;
        btn.setAttribute('aria-expanded', String(willOpen));
      });

      menu.querySelectorAll('.cbndl__dd-opt').forEach(function (optBtn) {
        optBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (optBtn.hasAttribute('disabled')) return;
          select.value = optBtn.getAttribute('data-value');
          select.dispatchEvent(new Event('change', { bubbles: true }));
          menu.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    });
    // Dong menu khi click ra ngoai
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-dd]')) closeAllMenus(null);
    });

    /* ---------------- Wire up events ---------------- */
    var suppress = false; // chan vong lap khi sync 2 chieu picker <-> tier

    root.querySelectorAll('.cbndl__select').forEach(function (s) {
      s.addEventListener('change', function () {
        var card = s.closest('.cbndl__card');
        renderCardPrice(card);
        updateDropdownDisplay(s);
        suppress = true; driveMainPicker(s); suppress = false; // chon o nao -> anh chinh + Color tren cung theo o do
        showError('');
      });
      updateDropdownDisplay(s);
    });

    cards.forEach(function (card) {
      renderCardPrice(card);
      var radio = card.querySelector('.cbndl__radio');
      radio.addEventListener('change', function () {
        if (radio.checked) {
          updateShipping(card);
          showError('');
        }
      });
    });

    updateShipping(selectedCard());

    /* -- Chieu nguoc: click Color o variant picker goc -> dien mau vao TAT CA o tier -- */
    function currentPickerColor() {
      var picker = document.querySelector('variant-selects, variant-radios');
      if (!picker) return null;
      var fs = picker.querySelector('fieldset') || picker;
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      var sel = picker.querySelector('select');
      return sel ? sel.value : null;
    }
    function fillTiersFromColor(color) {
      if (!color) return;
      root.querySelectorAll('.cbndl__select').forEach(function (s) {
        var matched = false;
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].dataset.option1 === color) { s.selectedIndex = i; matched = true; break; }
        }
        if (!matched) return;
        renderCardPrice(s.closest('.cbndl__card'));
        updateDropdownDisplay(s);
      });
    }
    // Dung event delegation tren document: Dawn REPLACE phan tu variant-selects
    // moi lan doi variant, nen listener gan truc tiep chi an 1 lan. Nghe o document
    // (change bubbles) thi song sot qua moi lan re-render.
    document.addEventListener('change', function (e) {
      if (suppress) return; // bo qua khi chinh widget vua dieu khien picker
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('variant-selects, variant-radios')) return;
      fillTiersFromColor(currentPickerColor());
    });

    /* ---------------- Submit -> /cart/add.js ---------------- */
    function setLoading(state) {
      submitBtn.disabled = state;
      if (spinner) spinner.hidden = !state;
      if (submitText) submitText.style.opacity = state ? '.6' : '1';
    }

    submitBtn.addEventListener('click', function () {
      showError('');
      var card = selectedCard();
      if (!card) { showError('Please choose an option.'); return; }

      var selects = card.querySelectorAll('.cbndl__select');
      var names = card.__cnNames || [];
      var bundleId = 'bndl_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var tierDiscount = parseInt(card.dataset.discount, 10) || 0;

      var items = [];
      var soldOut = false;
      selects.forEach(function (s, idx) {
        var d = optData(s);
        if (!d.available) { soldOut = true; return; }
        var props = { _bundle_id: bundleId };
        if (tierDiscount > 0) props._bundle_discount = String(tierDiscount);
        if (enableCustomName && names[idx]) props['Custom Name'] = names[idx];
        items.push({ id: parseInt(d.id, 10), quantity: 1, properties: props });
      });

      if (soldOut) { showError('One of the selected colors is sold out. Please pick another.'); return; }
      if (!items.length) { showError('Please select at least one color.'); return; }

      setLoading(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { if (!res.ok) throw data; return data; }); })
        .then(function (added) {
          if (cartBehavior === 'redirect') { window.location.href = '/cart'; return; }
          return refreshCartCount().then(function (cart) {
            var opened = cartBehavior !== 'count' ? notifyThemeCart(cart, added.items || items) : false;
            if (!opened) showToast('Added to cart ✓');
          });
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
          showError(msg);
        })
        .finally(function () { setLoading(false); });
    });
  }

  function bootAll() { document.querySelectorAll('[data-cbndl]').forEach(initBundle); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-cbndl]') : null;
    if (el) initBundle(el);
  });
})();
